import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Mask, Button, Dialog, Toast, Toptips, LoadMore } from 'react-weui'
import Clipboard from 'clipboard'
import { browserHistory } from 'react-router'
import { renderMoney, isLZWKAPP } from '../../utils'
import { toChatPage } from '../../services'
import { toLiveroom } from '../../utils/connectApp'
import Header from '../../components/liveroomLecturer/Header'
import { Page, WKTab } from '../../components'
import ResellPublishModal from './ResellPublishModal'
import { WKSearch, WkPanel, WKVisible, WKInfiniteScroll } from '../../components/wk'
import MediaItem from './MediaItem'
import '../../css/page/ResellPage.css'
import questionImg from '../../images/question.png'
import wxMomentImg from '../../images/wx-moment.png'
import vipImg from '../../images/resell/vip.png'
import frozenImg from '../../images/resell/frozen.png'
import invalidImg from '../../images/resell/invalid.png'

const appInviterId = '44813679'

class ResellLiveroomPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isShowModal: false,
            isShowQuestionModal: false,
            percent: 0,
            title: '',
            uid: '',
            isPending: false,
            publishData: null,
            liveroomState: '',
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
            liveroomInfo: {},
            vipInfo: null,

            lectures: [],
            lecturesOffset: 0,
            lecturesHasMore: true,
            lecturesIsPending: false,
            lecturesCount: '',
            channels: [],
            channelsOffset: 0,
            channelsHasMore: true,
            channelsIsPending: false,
            channelsCount: '',
        }
    }
    componentDidMount () {
        document.title = '店铺分销商'
        this.fetchInfo()
        this.fetchLectures()
        this.fetchChannels()
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    fetchInfo () {
        axios.get(`/api/resell/liveroom/${this.props.params.id}/info`)
            .then(res => {
                const data = res.data.data
                this.setState({
                    percent: data.liveroom_resell_info.percent,
                    title: data.liveroom.name,
                    liveroomAvatar: data.liveroom.avatar_url,
                    uid: data.liveroom.account_id,
                    liveroomState: data.state,
                    liveroomInfo: data.liveroom,
                    vipInfo: data.liveroom.vip_info,
                })
            })
    }
    fetchLectures () {
        this.setState({ lecturesIsPending: true })
        axios.get(`/api/resell/liveroom/${this.props.params.id}/lecture_list`, {
            params: {
                offset: this.state.lecturesOffset,
            }
        })
            .then(res => {
                const data = res.data.data
                this.setState({
                    lectures: this.state.lectures.concat(data.lectures),
                    lecturesHasMore: data.has_more,
                    lecturesIsPending: false,
                    lecturesOffset: data.next_offset,
                    lecturesCount: data.total_count,
                })
            })
    }
    fetchChannels () {
        this.setState({ channelsIsPending: true })
        axios.get(`/api/resell/liveroom/${this.props.params.id}/channel_list`, {
            params: {
                offset: this.state.channelsOffset,
            }
        })
            .then(res => {
                const data = res.data.data
                this.setState({
                    channels: this.state.channels.concat(data.channels),
                    channelsHasMore: data.has_more,
                    channelsIsPending: false,
                    channelsOffset: data.next_offset,
                    channelsCount: data.total_count,
                })
            })
    }
    onClickPublish (e, type, id) {
        e.stopPropagation()
        this.setState({ isPending: true })
        const inviterId = isLZWKAPP() ? appInviterId : '23526994'
        axios.get(`/api/resell/${type}/${id}/promo_info?st=lzwk_resell&inviter_id=${inviterId}`)
            .then(res => {
                const data = res.data.data
                if (type === 'vip') {
                    const publishData = data
                    publishData.object.cover_url = vipImg
                    publishData.object.name = 'VIP会员'
                    this.setState({ 
                        isPending: false,
                        isShowModal: true,
                        publishData,
                    }, () => this.initCopyboard())
                } else if (type === 'liveroom') {
                    const publishData = data
                    publishData.type = 'liveroom'
                    // publishData.object.cover_url = this.state.liveroomInfo.avatar_url
                    // publishData.object.name = this.state.liveroomInfo.name
                    this.setState({ 
                        isPending: false,
                        isShowModal: true,
                        publishData,
                    }, () => this.initCopyboard())
                } else {
                    this.setState({
                        isPending: false,
                        isShowModal: true,
                        publishData: data,
                    }, () => this.initCopyboard())
                }
                this.setShareInfo({
                    title: data.share_info.share_title,
                    desc: data.share_info.share_description,
                    imgUrl: data.share_info.share_icon,
                    link: data.share_info.share_url,
                })
            })
    }
    setShareInfo (data) {
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: data,
        })
    }
    onClickPublishClose () {
        this.setState({ isShowModal: false, publishData: null })
    }
    onClickGetInviteCard (type, id) {
        location.assign(`/${type}/${id}/sharecard`)
    }
    initCopyboard () {
        const clipboard = new Clipboard('#copy-btn')
        clipboard.on('success', (e) => {
            this.showTip('已复制到剪贴板', 'primary')
            e.clearSelection()
        })
    }
    renderLoadStyle() {
        const { channelsHasMore, channelsIsPending } = this.state
        if (channelsHasMore) {
            if (!channelsIsPending) {
                return (
                    <div className="weui-padding text-center loadmore-container wk-border-line-before wk-position-rlt" onClick={e => this.fetchChannels()}>
                        <a className="block text-center">
                            查看更多
                        </a>
                    </div>
                )
            } else {
                return (
                    <LoadMore loading className="loadmore wk-border-line-before wk-position-rlt">正在加载</LoadMore>
                )
            }
        } else {
            return null
        }
    }
    renderLiveroomVerifyTypeIcon(type) {
        if(type === 1){
            return <i className="iconfont verify-type-icon verify-type-icon-special icon-yfv"></i>
        }else if(type === 2){
            return <i className="iconfont verify-type-icon icon-yfv"></i>
        }
        return null
    }
    toLiveroom (id) {
        if (isLZWKAPP()) {
            toLiveroom(id)
        } else {
            location.assign(`/liveroom/${id}`)
        }
    }
    onClickItem (type, id) {
        if (isLZWKAPP()) {
            location.assign(`lizhiweike://${type}?${type}_id=${id}&inviter_id=${appInviterId}`)
        } else {
            location.assign(`/${type}/${id}`)            
        }
    }
    onClickVipPublish (e) {
        e.stopPropagation()
    }
    render() {
        const { publishData, liveroomInfo, vipInfo } = this.state
        const isEmpty = this.state.lecturesCount === 0 && this.state.channelsCount === 0
        const isFrozen = this.state.liveroomState === 'frozen'
        const isDel = this.state.liveroomState === 'delete_frozen' || this.state.liveroomState === 'rejected'
        return (
            <div className='goods-page'>
                <div className="topbar wk-border-line-after wk-position-rlt">
                    <div onClick={e => this.toLiveroom(liveroomInfo.id)} className="avatar" style={{backgroundImage: `url(${this.state.liveroomAvatar})`}}>
                        {this.renderLiveroomVerifyTypeIcon(liveroomInfo.verify_type)}
                    </div>
                    <div className="name" onClick={e => this.toLiveroom(liveroomInfo.id)}>{this.state.title}</div>
                    <div className="question" onClick={e => this.setState({ isShowQuestionModal: true })}>
                        <img src={questionImg} alt=""/>
                    </div>
                    <button onClick={e => this.onClickPublish(e, 'liveroom', liveroomInfo.id)}>赚钱</button>
                </div>
                <WKVisible create={isEmpty}>
                    <div className="resell-page-empty">
                        暂无合作店铺记录
                    </div>
                </WKVisible>
                <WKVisible create={isFrozen} className='empty-wrap'>
                    <div className="content">
                        <img src={frozenImg} alt=""/>
                        <div className="text">
                            <p>当前状态为已冻结，将无法继续</p>
                            <p>以店铺分销商身份进行分销</p>
                        </div>
                        <Button onClick={e => toChatPage(this.state.uid)}>联系店铺</Button>
                    </div>
                </WKVisible>
                <WKVisible create={isDel} className='empty-wrap'>
                    <div className="content">
                        <img src={invalidImg} alt=""/>
                        <div className="text">
                            <p>当前状态为已失效，将无法继续</p>
                            <p>以店铺分销商身份进行分销</p>
                        </div>
                        <Button onClick={e => location.assign(`/resell/liveroom/${this.props.params.id}/recruit`)}>重新申请</Button>
                    </div>
                </WKVisible>

                {/* vip */}
                {
                    vipInfo && vipInfo.vip_fee !== 0 && (
                        <WkPanel title='VIP' isNoPadding={true} className='margin-bottom'>
                            {
                                <MediaItem
                                    onClick={e => location.assign(`/liveroom/vip?liveroom_id=${liveroomInfo.id}`)} 
                                    content={{
                                        cover: vipImg,
                                        topText: 'VIP会员',
                                        middleText: `金额：¥${renderMoney(vipInfo.vip_fee)}`,
                                        bottomText: `预计佣金：${this.state.percent}%（￥${renderMoney(vipInfo.vip_fee * this.state.percent / 100)}）`,
                                        fixed: <button onClick={e => this.onClickPublish(e, 'vip', liveroomInfo.id)}>赚钱</button>,
                                    }}
                                />
                            }
                        </WkPanel>
                    )
                    
                }

                <WKVisible create={!isEmpty && !isFrozen && !isDel}>
                    <WKVisible create={this.state.channels.length > 0}>
                        <WkPanel title='专栏' isNoPadding={true}>
                            {
                                this.state.channels.map(item => (
                                    <MediaItem
                                        key={item.id}
                                        onClick={e => this.onClickItem('channel', item.id)} 
                                        content={{
                                            cover: item.cover_url,
                                            topText: item.name,
                                            middleText: `金额：¥${renderMoney(item.money)}`,
                                            bottomText: `预计佣金：${this.state.percent}%（￥${renderMoney(item.money * this.state.percent / 100)}）`,
                                            fixed: <button onClick={e => this.onClickPublish(e, 'channel', item.id)}>赚钱</button>,
                                        }}
                                    />
                                ))
                            }
                        </WkPanel>
                        {this.renderLoadStyle()}
                    </WKVisible>
                    <WKVisible create={this.state.lectures.length > 0}>
                        <WkPanel title='课程' isNoPadding={true} className='margin-top'>
                            {
                                this.state.lectures.map(item => (
                                    <MediaItem
                                        key={item.id}
                                        onClick={e => this.onClickItem('lecture', item.id)} 
                                        content={{
                                            cover: item.cover_url,
                                            topText: item.name,
                                            middleText: `金额：¥${renderMoney(item.money)}`,
                                            bottomText: `预计佣金：${this.state.percent}%（￥${renderMoney(item.money * this.state.percent / 100)}）`,
                                            fixed: <button onClick={e => this.onClickPublish(e, 'lecture', item.id)}>赚钱</button>,
                                        }}
                                    />
                                ))
                            }
                        </WkPanel>
                    </WKVisible>
                    <WKInfiniteScroll 
                        onTouchBottom={() => this.fetchLectures()} 
                        isStop={this.state.lecturesIsPending || this.props.selectId != 0} 
                        isKill={!this.state.lecturesHasMore}
                        isShowLoading={true}
                    />
                </WKVisible>
                
                {/* 推广弹窗 */}
                {
                    publishData && (
                        <ResellPublishModal
                            onClickPublishClose={() => this.onClickPublishClose()}
                            publishData={publishData}
                            vipInfo={vipInfo}
                        />
                    )
                }

                <Dialog type="ios" title='' buttons={[
                    { label: '知道了', onClick: () => this.setState({ isShowQuestionModal: false }) }
                ]} show={this.state.isShowQuestionModal}>
                    若店铺管理者修改商品价格和佣金比例将会实时更新，以成单价格和佣金比例为准
                </Dialog>

                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
                
            </div>
        )
    }
}

export default connect(state => ({

}))(ResellLiveroomPage)


// WEBPACK FOOTER //
// ./src/pages/resell/ResellLiveroomGoods.js